import lodash from 'lodash';
import { Swiper } from 'swiper';
import { EffectFade, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

export const Tabswiper = {
  init() {
    if (document.querySelectorAll('.js-swipetab').length) {
      const els = document.querySelectorAll('.js-swipetab');
      els.forEach((el) => {
        const tabs = el.querySelectorAll('.js-swipetab-pagination > *');
        if (tabs.length == 0) {
          console.error(`Not found tabs`);
          return false;
        }
        const main = el.querySelector('.js-swipetab-main');
        if (!lodash.isElement(main)) {
          console.error(`Not found main`);
          return false;
        }
        const slides = main.querySelectorAll('.swiper-slide');
        if (tabs.length != slides.length) {
          console.error(`Not match slides.length`);
          return false;
        }

        new Swiper(main, {
          allowTouchMove: false,
          loop: true,
          modules: [EffectFade, Pagination],
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          speed: 1000,
          autoHeight: true,
          pagination: {
            el: el.querySelector('.js-swipetab-pagination'),
            bulletActiveClass: 'is-active',
            bulletClass: '-bullet',
            clickable: true,
            renderBullet: (index, className) => {
              return `<span role="button" class="${className} ${tabs[index].className}">${tabs[index].innerHTML}</span>`;
            },
          },
        });
      });
    }
  },
};
